import { useContext } from "react";
import { MainContext } from "context";
import { Server } from "server";

export const useServer = () : Readonly<Server> => {
    const { server } = useContext(MainContext);
    return server;
}